import { useNavigate } from "react-router-dom";
import { ThinButton } from "../../../Buttons/ThinButton/ThinButton";
import { Modal } from "../../Modal";
import challengesIcon from './icons/challenges.png';
import { AppContext } from "../../../Menu/MenuButton";
import { FC, useState } from "react";
import { useTracking } from "../../../../hooks/traking";
import { Fragment } from "../../../Fragment/Fragment";
import styles from './ChallengeIntroNotify.module.scss';

interface IChallengeIntroNotifyProps {
    closeHandler: () => void;
}

export const ChallengeIntroNotify: FC<IChallengeIntroNotifyProps> = ({ closeHandler }) => {
    const navigate = useNavigate();
    const { trackClick } = useTracking('ChallengeIntroNotify');
    const [startTime] = useState(Date.now());

    const getDisplayTime = () => Date.now() - startTime;

    const gotoChallenges = () => {
        trackClick('go-to-сhallenges', { value: getDisplayTime() });
        navigate(AppContext.Challenges);
        closeHandler();
    }

    const onClose = () => {
        trackClick('close', { value: getDisplayTime() });
        closeHandler();
    }

    const getContext = () => {
        return (
            <>
                <p>
                    <span>Там можно заработать</span>
                    <span className={styles.fragment}><Fragment /></span>
                    <span>фрагменты и другие награды.</span>
                </p>
                <p>К тому же, испытания — отличный способ быстрее освоить игру.</p>
            </>
        );
    }
    
    return (
        <Modal
            name='ChallengeIntroNotify'
            title='Начните с раздела «Испытания»'
            message={ getContext() }
            icon={challengesIcon}
            button={<ThinButton caption='Посмотреть испытания' handler={ () => gotoChallenges() } />}
            closeCross={{ onClose, showAfter: 4 }}
        />
    );
}